import React from "react";
import { Button, ConfigProvider, Typography, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

const DEFAULT_SEPARATOR = "、";

export function formatCopyableList(items, separator = DEFAULT_SEPARATOR) {
    if (!Array.isArray(items)) {
        return "";
    }

    return items
        .map((item) => String(item).trim())
        .filter(Boolean)
        .join(separator);
}

const CopyableItemList = ({ items = [], emptyText = "未填写", separator = DEFAULT_SEPARATOR, hideWhenEmpty = false }) => {
    const copyText = formatCopyableList(items, separator);

    if (!copyText) {
        if (hideWhenEmpty) {
            return null;
        }
        return <span style={{ color: "#999" }}>{emptyText}</span>;
    }

    const handleCopy = async () => {
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(copyText);
            } else {
                const textarea = document.createElement("textarea");
                textarea.value = copyText;
                textarea.setAttribute("readonly", "");
                textarea.style.position = "absolute";
                textarea.style.left = "-9999px";
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }
            message.success("已复制");
        } catch (error) {
            message.error("复制失败");
        }
    };

    return (
        <ConfigProvider componentDisabled={false}>
            <div>
                <Typography.Paragraph style={{ marginBottom: 8, userSelect: "text", whiteSpace: "pre-wrap" }}>{copyText}</Typography.Paragraph>
                <Button type="link" size="small" icon={<CopyOutlined aria-hidden />} aria-label="复制全部" onClick={handleCopy} style={{ padding: 0, height: "auto" }}>
                    复制全部
                </Button>
            </div>
        </ConfigProvider>
    );
};

export default CopyableItemList;
